import { createFileRoute } from "@tanstack/react-router";
import { legacyRedirectTo } from "@/lib/legacy-redirect";

// Legacy URL /clients → redirect to /admin/clients (staff-only page).
// The old beforeLoad auth check is replaced by the root __root.tsx gate,
// which enforces cross-role URL separation at the router level.
export const Route = createFileRoute("/clients/")({
  beforeLoad: legacyRedirectTo("/admin/clients"),
  component: () => null,
});
